import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  FormGroup,
  IconButton,
  Container,
  Button,
  FormControl,
  InputLabel,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { useQuery } from "hooks/useQuery";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Controller, useFieldArray, useForm } from "react-hook-form";

// Services
import { addSurveysResponse, getSurveys } from "services/surveys";
import Error from "components/Error";
import { getAppToken } from "services/auth";

const Main = styled(Container)`
  padding: 30px;
`;

const Surveys = ({ props }) => {
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();
  const { fields } = useFieldArray({ control, name: "questions" });
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [loadingSave, setloadingSave] = useState(false);
  //results
  const [messageError, setMessageError] = useState();
  const [succesMessage, setSuccesMessage] = useState();
  const [existingToken, setExistingToken] = useState(false);

  const query = useQuery();
  const uuid = query.get("a");
  const brandId = query.get("b");
  const surveyId = query.get("c");
  props.setCurrentBrand(brandId);

  const getAuthToken = async (interval) => {
    try {
      const response = await getAppToken();
      if (response.data) {
        localStorage.setItem("access_token_bt", response.data.access_token);
        localStorage.setItem("refresh_token_bt", response.data.access_token);
        clearInterval(interval);
        setExistingToken(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (brandId && !existingToken) {
      const interval = setInterval(() => {
        getAuthToken(interval);
      }, 1000);
    }
  }, [brandId]);

  useEffect(() => {
    localStorage.setItem("current_brand", brandId);
    setLoading(true);
    getSurveys(surveyId, uuid)
      .then(({ data }) => {
        if (data.status === "success") {
          setData(data.data);
          setValue("questions", data.data?.questions ?? []);
        } else {
          setMessageError(
            Array.isArray(data?.message)
              ? data?.message[0]
              : data?.message ?? "Error, intente de nuevo."
          );
        }
      })
      .catch(({ err }) => {
        setMessageError(
          Array.isArray(err?.message)
            ? err?.message[0]
            : err?.message ?? "Error, intente de nuevo."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onSubmit = (formData) => {
    const payload = {
      ...formData,
      surveys_id: surveyId,
      agreement_lines_uuid: uuid,
      sales_channel_id: 2
    };
    setloadingSave(true);

    addSurveysResponse(payload)
      .then(({ data }) => {
        if (data.status == "success") {
          setSuccesMessage("Creado");
        } else {
          throw data;
        }
      })
      .catch((err) => {
        setMessageError(
          Array.isArray(err?.message)
            ? err?.message[0]
            : err?.message ?? "Error, intente de nuevo."
        );
      })
      .finally(() => setloadingSave(false));
      setTimeout(() => {
        window.location.replace("https://bodytech.com.co");
      }, 500)
  };

  const onError = () => {};

  if (loading) {
    return (
      <Box
        maxWidth="100%"
        height="98vh"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Main maxWidth="md">
      {messageError && (
        <Grid item xs={12}>
          <Error customTitle={messageError?.message} linkButton={""} />
        </Grid>
      )}

      {succesMessage && (
        <Grid item xs={12}>
          <Error
            customTitle={succesMessage}
            linkButton={""}
            customMessage={"Gracias."}
          />
        </Grid>
      )}

      {!messageError && !succesMessage && (
        <Box
          component="form"
          sx={{ padding: 3 }}
          onSubmit={handleSubmit(onSubmit, onError)}
        >
          <Typography variant="h4">{data.name}</Typography>
          <Grid container spacing={2} sx={{ marginTop: 2 }}>
            {fields.map((question, index) => (
              <Grid item xs={12} key={index}>
                <Typography variant="h6">{question.question_text}</Typography>

                {question.type === "Respuesta corta" && (
                  <Controller
                    name={`questions.${index}.awnsers`}
                    control={control}
                    rules={{ required: "Este campo es obligatorio" }}
                    render={({ field }) => (
                      <TextField
                        fullWidth
                        variant="outlined"
                        {...field}
                        error={!!errors.question?.[index]?.awnsers}
                        helperText={
                          errors.question?.[index]?.awnsers?.message
                        }
                      />
                    )}
                  />
                )}

                {question.type === "Opción múltiple" && (
                  <>
                    {question?.options?.map((option, optionIndex) => (
                      <Controller
                        name={`questions.${index}.awnsers`}
                        control={control}
                        rules={{ required: "Selecciona una opción" }}
                        render={({ field }) => (
                          <RadioGroup {...field}>
                            <FormControlLabel
                              key={option.currentId}
                              value={option?.currentId}
                              control={
                                <Radio
                                  checked={field.value == option.currentId}
                                />
                              }
                              label={option.option_text}
                            />
                          </RadioGroup>
                        )}
                      />
                    ))}
                  </>
                )}

                {question.type === "Lista desplegable" && (
                  <Controller
                    name={`questions.${index}.awnsers`}
                    control={control}
                    defaultValue=""
                    rules={{ required: "Selecciona una opción" }}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select {...field} displayEmpty>
                          <MenuItem value="" disabled>
                            Selecciona una opción
                          </MenuItem>
                          {question.options.map((option) => (
                            <MenuItem key={option.currentId} value={option.currentId}>
                              {option.option_text}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                )}

                {question.type === "Calificación" && (
                  <Controller
                    name={`questions.${index}.awnsers`}
                    control={control}
                    render={({ field }) => (
                      <Box>
                        {[1, 2, 3, 4, 5].map((star) => (
                          <IconButton
                            key={star}
                            onClick={() => field.onChange(star)}
                          >
                            {star <= (field.value || 0) ? (
                              <StarIcon color="primary" />
                            ) : (
                              <StarBorderIcon />
                            )}
                          </IconButton>
                        ))}
                      </Box>
                    )}
                  />
                )}

                {question.type === "Párrafo" && (
                  <Controller
                    name={`questions.${index}.awnsers`}
                    control={control}
                    rules={{ required: "Este campo es obligatorio" }}
                    render={({ field }) => (
                      <TextField
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={4}
                        inputProps={{ maxLength: 1000 }}
                        {...field}
                        error={!!errors[`questions.${index}.awnsers`]}
                        helperText={
                          errors[`questions.${index}.awnsers`]?.message
                        }
                      />
                    )}
                  />
                )}

                {question.type === "Casillas de verificación" && (
                  <>
                    {question?.options?.map((option, optionIndex) => (
                      <Controller
                        name={`questions.${index}.awnsers`}
                        control={control}
                        rules={{ required: "Selecciona una opción" }}
                        render={({ field }) => (
                          <FormGroup>
                            <FormControlLabel
                              key={option.currentId}
                              control={
                                <Checkbox
                                  checked={
                                    field.value?.includes(option.currentId) || false
                                  }
                                  onChange={() => {
                                    const current = field.value || [];
                                    const newValue = current.includes(option.currentId)
                                      ? current.filter(
                                          (text) => text !== option.currentId
                                        )
                                      : [...current, option.currentId];
                                    field.onChange(newValue);
                                  }}
                                />
                              }
                              label={option.option_text}
                            />
                          </FormGroup>
                        )}
                      />
                    ))}
                  </>
                )}
              </Grid>
            ))}
          </Grid>

          <Button variant="contained" color="primary" type="submit">
            {loadingSave ? <CircularProgress color="inherit" /> : "Guardar"}
          </Button>
        </Box>
      )}
    </Main>
  );
};

export default Surveys;
